<template>
  <b-modal title="Detalhes da Medição de Espessura" v-model="show" size="xl">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="6">
          <b-form-group label="Material:" label-for="material" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="material" v-model="template.material" />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Técnica:" label-for="tecnica" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="tecnica" v-model="template.tecnica" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-form-group label="Superfície:" label-for="superficie" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="superficie" v-model="template.superficie" />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Transdutor:" label-for="transdutor" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="transdutor" v-model="template.transdutor" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-form-group label="Velocidade:" label-for="velocidade" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="velocidade" v-model="template.velocidade" />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Acoplante:" label-for="acoplante" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="acoplante" v-model="template.acoplante" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-form-group label="Temperatura:" label-for="temperatura" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="temperatura" v-model="template.temperatura" />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Procedimento:" label-for="procedimento" label-cols-sm="3" label-align-sm="right">
            <b-form-select v-model="template.procedimento">
              <b-form-select-option v-for="documento of getDocumentos" v-bind:key="documento.id" :value="documento.numero"
                >{{ documento.descricao }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-form-group label="Medidor:" label-for="medidor" label-cols-sm="3" label-align-sm="right">
            <b-form-select v-model="template.medidor">
              <b-form-select-option v-for="instrumento of getInstrumentos" v-bind:key="instrumento.id" :value="instrumento"
                >{{ instrumento.descricao }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Bloco:" label-for="bloco" label-cols-sm="3" label-align-sm="right">
            <b-form-select v-model="template.bloco">
              <b-form-select-option v-for="instrumento of getInstrumentos" v-bind:key="instrumento.id" :value="instrumento"
                >{{ instrumento.descricao }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-form-group label-cols-sm="2" label="Observação:" label-align-sm="center">
            <b-form-textarea v-model="template.observacao" rows="3"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>

      <hr />
      <b-row>
        <b-col cols="6">
          <b-form-group label="Inspetor:" label-for="inspetor" label-cols-sm="3" label-align-sm="right">
            <b-form-select v-model="template.inspetor">
              <b-form-select-option v-for="profissional of getProfissionais" v-bind:key="profissional.id" :value="profissional"
                >{{ profissional.nome }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { useDocumentoStore } from "@/stores/DocumentoStore";
import { useInstrumentoStore } from "@/stores/InstrumentoStore";
import { useProfissionalStore } from "@/stores/ProfissionalStore";
import { storeToRefs } from "pinia";
import MedicaoEspessura from "@/models_reports/MedicaoEspessura";

export default {
  name: "ModalDeTemplateME",

  components: {},

  data() {
    return {
      show: false,
      template: new MedicaoEspessura(),
    };
  },

  methods: {
    call(me) {
      this.show = !this.show;
      this.template = me;
    },
  },

  setup() {
    const store = useSgcqStore();
    const documentoStore = useDocumentoStore();
    const { getDocumentos } = storeToRefs(documentoStore);
    const instrumentoStore = useInstrumentoStore();
    const { getInstrumentos } = storeToRefs(instrumentoStore);
    const profissionalStore = useProfissionalStore();
    const { getProfissionais } = storeToRefs(profissionalStore);

    return {
      store,
      documentoStore,
      getDocumentos,
      instrumentoStore,
      getInstrumentos,
      profissionalStore,
      getProfissionais,
    };
  },
};
</script>

<style lang="scss" scoped></style>
